import variableApi from '@/api/variable';

const SET_TIMELINE_DATA = 'SET_TIMELINE_DATA';
const SET_TIMELINE_DATES = 'SET_TIMELINE_DATES';

const state = {
  timeline: {
    variables: [],
    startDate: undefined,
    endDate: undefined
  }
};

const getters = {
  getTimelineData: state => {
    return state.timeline;
  }
};

const mutations = {
  [SET_TIMELINE_DATA] (state, data) {
    state.timeline.variables = data.variables;
  },
  [SET_TIMELINE_DATES] (state, {startDate, endDate}) {
    state.timeline.startDate = startDate;
    state.timeline.endDate = endDate;
  }
};

const actions = {
  retrieveTimelineData ({ commit }, { context, variableIds, startDate, endDate }) {
    variableApi.getTimelineData(context, variableIds, startDate.toISOString(), endDate.toISOString()).then(data => {
      commit(SET_TIMELINE_DATES, {startDate, endDate});
      commit(SET_TIMELINE_DATA, data);
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/explorerTimeline/index.js